import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// Phase 7 sign-off: profile email.
import { MAX_LENGTHS, useCappedPaste } from '../../utils/inputValidation';
import { isFieldOk, parseServerInputError } from '../../utils/inputFormHelpers';

const SignupBanner = () => {
  const { i18n } = useTranslation();
  const isKo = i18n.language === 'ko';
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // null | 'loading' | 'success' | 'error'
  const [msg, setMsg] = useState('');
  const onEmailPaste = useCappedPaste(MAX_LENGTHS.email);

  const handleSubmit = async () => {
    const emailResult = isFieldOk(email, 'email');
    if (!emailResult.ok) {
      setStatus('error');
      setMsg(isKo ? '올바른 이메일을 입력해주세요.' : (emailResult.message || 'Please enter a valid email.'));
      return;
    }
    setStatus('loading');
    try {
      const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:8000';
      const res = await fetch(`${apiBase}/api/v1/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, locale: i18n.language }),
      });
      if (!res.ok) {
        const parsed = await parseServerInputError(res, {
          fallback: isKo ? '오류가 발생했습니다.' : 'Something went wrong.',
        });
        throw new Error(parsed.message);
      }
      setStatus('success');
      setMsg(isKo ? '등록 완료! 이메일을 확인해주세요.' : 'Registered! Check your email.');
      setEmail('');
    } catch (err) {
      setStatus('error');
      setMsg(err.message || (isKo ? '오류가 발생했습니다.' : 'Something went wrong.'));
    }
  };

  return (
    <section className="signup-banner">
      <div className="wrap signup-inner">
        <strong>{isKo ? '🚀 얼리액세스 신청하기 —' : '🚀 Apply for Early Access -'}</strong>
        <input
          className="signup-input"
          type="email"
          placeholder={isKo ? '이메일 주소를 입력하세요' : 'Enter your email address'}
          value={email}
          onChange={(e) => { setEmail(e.target.value); setStatus(null); }}
          onPaste={onEmailPaste}
          maxLength={MAX_LENGTHS.email}
          autoComplete="email"
          disabled={status === 'loading'}
        />
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={status === 'loading'}
          style={{ border: 'none', cursor: status === 'loading' ? 'wait' : 'pointer' }}
        >
          {status === 'loading'
            ? '...'
            : isKo ? '알림 받기' : 'Notify Me'}
        </button>
        {status === 'success' && <span style={{ fontSize: 12, color: '#86EFAC' }}>{msg}</span>}
        {status === 'error' && <span style={{ fontSize: 12, color: '#F87171' }}>{msg}</span>}
        {!status && (
          <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>
            {isKo ? '스팸 없음. 언제든 구독 취소 가능.' : 'No spam. Unsubscribe anytime.'}
          </span>
        )}
      </div>
    </section>
  );
};

export default SignupBanner;
